import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Plane, ArrowRight } from "lucide-react";

/**
 * 404 catch-all — prevents any unmatched URL from rendering a blank page above the footer.
 * Common causes: bad Stripe redirect, mis-typed URL, external link pointing to a moved route.
 */
export default function NotFound() {
  const loc = useLocation();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="page-404">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex h-14 w-14 rounded-full bg-cyan/10 border border-cyan/40 items-center justify-center mb-5">
          <Plane className="h-6 w-6 text-cyan -rotate-45" />
        </div>
        <div className="mono text-[10px] tracking-widest text-cyan/80 mb-2">// 404 · SQUAWK 7500</div>
        <h1 className="font-display font-bold text-4xl mb-3 tracking-tight">Off route.</h1>
        <p className="text-sm text-white/60 mb-1">We can't find this page in the flight plan.</p>
        <div className="mono text-[10px] text-white/35 mb-8">{loc.pathname}</div>
        <div className="flex justify-center gap-2 flex-wrap">
          <Link to="/dashboard" className="btn btn-primary" data-testid="404-go-dashboard">
            Cockpit dashboard <ArrowRight className="h-3.5 w-3.5" />
          </Link>
          <Link to="/" className="btn" data-testid="404-go-home">Home</Link>
        </div>
      </div>
    </div>
  );
}
